var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"white"}},[_c('iframe',{ref:"iframe",attrs:{"src":_vm.url,"width":"100%","height":"600px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }